export const routeName = 'ReclamationListPage'

export const route = {
  path: '/reclamation/list/:status?',
  name: routeName,
  component: () => import('./ReclamationListPage.vue')
}
